import React, { useState } from 'react';
import { sendCommand } from '../mqttClient';

const COMMANDS = [
  {
    label: 'Re-Authenticate',
    cmd  : 'REAUTH',
    desc : 'Collect 200 ECG samples',
    grad : 'linear-gradient(135deg, #6366f1, #4f46e5)',
    shadow: 'rgba(99,102,241,0.35)',
    icon : '🔑',
  },
  {
    label: 'Reset Device',
    cmd  : 'RESET',
    desc : 'Clear auth & baseline',
    grad : 'linear-gradient(135deg, #f59e0b, #d97706)',
    shadow: 'rgba(245,158,11,0.35)',
    icon : '↺',
  },
  {
    label: 'Calibrate',
    cmd  : 'CALIB',
    desc : 'Re-enroll ECG baseline',
    grad : 'linear-gradient(135deg, #10b981, #059669)',
    shadow: 'rgba(16,185,129,0.35)',
    icon : '⚙',
  },
];

export default function CommandButtons() {
  const [sent, setSent] = useState('');
  const [hover, setHover] = useState('');

  const handle = (cmd) => {
    sendCommand(cmd);
    setSent(cmd);
    setTimeout(() => setSent(''), 2500);
  };

  return (
    <div style={s.grid}>
      {COMMANDS.map(({ label, cmd, desc, grad, shadow, icon }) => {
        const isSent  = sent  === cmd;
        const isHover = hover === cmd;
        return (
          <button
            key={cmd}
            style={{
              ...s.btn,
              background  : isSent ? grad : isHover ? grad : 'rgba(255,255,255,0.8)',
              color       : isSent || isHover ? '#fff' : '#374151',
              border      : isSent || isHover ? '1px solid transparent' : '1px solid #e5e7eb',
              boxShadow   : isSent || isHover ? `0 6px 20px ${shadow}` : '0 2px 8px rgba(0,0,0,0.04)',
              transform   : isHover ? 'translateY(-2px)' : 'none',
            }}
            onClick={() => handle(cmd)}
            onMouseEnter={() => setHover(cmd)}
            onMouseLeave={() => setHover('')}
          >
            <span style={s.btnIcon}>{isSent ? '✓' : icon}</span>
            <div style={s.btnText}>
              <span style={s.btnLabel}>{isSent ? 'Sent!' : label}</span>
              <span style={{ ...s.btnDesc, color: isSent || isHover ? 'rgba(255,255,255,0.75)' : '#9ca3af' }}>
                {isSent ? 'Command dispatched' : desc}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}

const s = {
  grid: { display: 'flex', flexDirection: 'column', gap: 8 },
  btn : {
    display     : 'flex',
    alignItems  : 'center',
    gap         : 12,
    padding     : '11px 14px',
    borderRadius: 12,
    cursor      : 'pointer',
    transition  : 'all .18s ease',
    textAlign   : 'left',
    fontFamily  : 'Inter, sans-serif',
    width       : '100%',
  },
  btnIcon : { fontSize: 18, flexShrink: 0, width: 24, textAlign: 'center' },
  btnText : { display: 'flex', flexDirection: 'column', gap: 1 },
  btnLabel: { fontSize: 13, fontWeight: 700, display: 'block' },
  btnDesc : { fontSize: 11, fontWeight: 500, display: 'block' },
};
